module.exports = __webpack_public_path__ + "img/30.fa19f3a1.jpg";